var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuicideAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 48V16C80 11.5817 76.4183 8 72 8H22C17.5817 8 14 11.5817 14 16V80C14 84.4183 17.5817 88 22 88H44",
    stroke: "#8B93A7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28H67",
    stroke: "#8B93A7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42H48",
    stroke: "#8B93A7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1232 63.3774H79.1514C78.9832 60.318 77.794 57.4649 75.7561 55.2777C73.5499 52.9102 70.619 51.6082 67.5 51.6082C64.381 51.6082 61.4501 52.9102 59.2479 55.2777C57.21 57.4649 56.0168 60.318 55.8486 63.3774H51.8768C51.104 63.3774 50.4754 64.052 50.4754 64.8813V88.8879C50.4754 89.7172 51.104 90.3918 51.8768 90.3918H83.1232C83.896 90.3918 84.5246 89.7172 84.5246 88.8879V64.8813C84.5246 64.052 83.896 63.3774 83.1232 63.3774ZM67.5 54.616C72.1525 54.616 75.9803 58.4832 76.3406 63.3774H58.6594C59.0197 58.4832 62.8475 54.616 67.5 54.616ZM81.7219 87.384H53.2781V66.3852H81.7219V87.384Z",
    fill: "#8B93A7",
    stroke: "#8B93A7",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9024 75.9629V82.2062C65.9024 83.0785 66.5591 83.7832 67.3719 83.7832H67.6041C68.4169 83.7832 69.0735 83.0785 69.0735 82.2062V75.834C70.2387 75.1723 71.0355 73.8574 71.0355 72.3449C71.0355 70.1664 69.3898 68.4004 67.3599 68.4004C65.3299 68.4004 63.6843 70.1664 63.6843 72.3449C63.6843 73.9648 64.5972 75.357 65.9024 75.9629Z",
    fill: "#8B93A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuicideAvatar);
export default __webpack_public_path__ + "static/media/suicide-avatar.6f5de52e2b51939153ca9d2261e82dd8.svg";
export { ForwardRef as ReactComponent };